import { ReactNode, useContext } from "react";
import { Navigate } from "react-router";
import { UserRoles } from "../../models/user";
import { AppCtx } from "../../provider/AppContext";

interface RoleRouteProps {
    roles: UserRoles[];
    children: ReactNode;
}

/**
 * Guard per ruolo. Le rotte /admin stavano solo dentro ProtectedRoute, quindi erano
 * raggiungibili da qualunque utente autenticato.
 *
 * Resta una difesa di sola interfaccia: l'autorizzazione vera è quella del server,
 * perché il ruolo qui arriva da localStorage ed è manipolabile dall'utente.
 */
function RoleRoute({ roles, children }: RoleRouteProps) {
    const appContex = useContext(AppCtx);

    if (!appContex.user || !roles.includes(appContex.user.role as UserRoles))
        return <Navigate to="/home" replace />;

    return <>{children}</>;
}

export default RoleRoute;
